<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.23864 9.99264L11.4239 5.21967C11.7421 4.92677 12.2579 4.92677 12.5761 5.21967L17.7614 9.99264C18.0795 10.2855 18.0795 10.7604 17.7614 11.0533C17.4432 11.3462 16.9273 11.3462 16.6091 11.0533L12.8148 7.56066L12.8148 18.25C12.8148 18.6642 12.45 19 12 19C11.55 19 11.1852 18.6642 11.1852 18.25L11.1852 7.56066L7.39091 11.0533C7.07272 11.3462 6.55683 11.3462 6.23864 11.0533C5.92045 10.7604 5.92045 10.2855 6.23864 9.99264Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 21.2C17.081 21.2 21.2 17.081 21.2 12C21.2 6.91898 17.081 2.8 12 2.8C6.91898 2.8 2.8 6.91898 2.8 12C2.8 17.081 6.91898 21.2 12 21.2ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default { name: 'Upgrade' };
</script>

<style scoped lang="scss" type="text/scss">

</style>
